import { z } from 'zod';
/** Listing upload API (contracts/archivo-listado.md, RF-02..RF-05). Shared by api and web. */
export const advertenciaListadoSchema = z.discriminatedUnion('codigo', [
    z.object({
        codigo: z.literal('CORREO_UNIFICADO'),
        correo: z.string(),
        centros_costo: z.array(z.string()),
    }),
    z.object({ codigo: z.literal('FILA_DUPLICADA'), fila: z.number() }),
    z.object({ codigo: z.literal('CENTRO_COSTO_REPETIDO'), centro_costo: z.string() }),
    z.object({ codigo: z.literal('COLUMNA_IGNORADA'), columna: z.string() }),
    z.object({ codigo: z.literal('LISTADO_SIN_CAMBIOS') }),
]);
export const errorListadoSchema = z.discriminatedUnion('codigo', [
    z.object({ codigo: z.literal('COLUMNA_FALTANTE'), columna: z.string() }),
    z.object({ codigo: z.literal('ARCHIVO_VACIO') }),
    z.object({ codigo: z.literal('CELDA_VACIA'), fila: z.number(), columna: z.string() }),
    z.object({ codigo: z.literal('CORREO_INVALIDO'), fila: z.number(), columna: z.string() }),
    z.object({ codigo: z.literal('FORMATO_NO_SOPORTADO') }),
]);
export const resultadoCargueSchema = z.object({
    resultado: z.enum(['aceptado', 'rechazado']),
    periodo: z.string(),
    centros_costo: z.number(),
    destinatarios: z.number(),
    advertencias: z.array(z.object({ codigo: z.string(), mensaje: z.string() }).passthrough()),
    errores: z.array(z.object({ codigo: z.string(), mensaje: z.string() }).passthrough()),
});
export const listadoResumenSchema = z.object({
    id: z.string().uuid(),
    periodo: z.string(),
    estado: z.enum(['vigente', 'reemplazado', 'rechazado']),
    archivoNombre: z.string(),
    /** `manual` (uploaded on screen) or `drive` (read from the shared folder) */
    origen: z.enum(['manual', 'drive']),
    archivoModificadoPor: z.string().nullable(),
    cargadoPor: z.string(),
    cargadoEn: z.string(),
});
export const listadoVigenteSchema = z.object({
    id: z.string().uuid(),
    periodo: z.string(),
    cargadoEn: z.string(),
    centros: z.array(z.object({
        codigo: z.string(),
        nombreProyecto: z.string(),
        tercero: z.string(),
        /** every email that receives this cost center; each one gets its own link */
        correos: z.array(z.string()),
    })),
    destinatarios: z.number(),
});
/** Where the listing comes from (GET /api/admin/listados/origen). */
export const archivoRemotoSchema = z.object({
    nombre: z.string(),
    modificadoEn: z.string(),
    modificadoPor: z.string().nullable(),
});
export const listadoOrigenSchema = z.discriminatedUnion('origen', [
    z.object({ origen: z.literal('manual') }),
    z.object({
        origen: z.literal('drive'),
        carpetaUrl: z.string(),
        /** null when the folder has no supported file */
        archivo: archivoRemotoSchema.nullable(),
        /** catalogue message when the folder could not be read */
        error: z.string().optional(),
    }),
]);
/** POST /api/admin/periodos/{periodo}/envio: listing taken from its source, then publication. */
export const resultadoEnvioSchema = z.object({
    listado: resultadoCargueSchema.nullable(),
    publicacion: z.object({ id: z.string(), estado: z.string(), nueva: z.boolean() }).nullable(),
});
//# sourceMappingURL=listado.js.map